import CaseStudy from './CaseStudy';
import CaseStudies from './CaseStudies';

export default CaseStudies;
export { CaseStudy };
